import { render, staticRenderFns } from "./TepViajeEdit.vue?vue&type=template&id=222bb974"
import script from "./TepViajeEdit.vue?vue&type=script&lang=js"
export * from "./TepViajeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports